import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=2a6604b3"
import script from "./form-checkbox.vue?vue&type=script&lang=js"
export * from "./form-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports